<template>
  <b-card no-body v-if="payment_methods">
    <b-card-header>
      <h3 class="mb-0">Payment Methods</h3>
    </b-card-header>
    <loading-panel v-if="loading"></loading-panel>
    <b-table responsive id="payments" small :items="payment_methods" :fields="fields" v-else>
      <template #cell(actions)="row">
        <b-button size="sm" variant="danger" @click="removePaymentMethod(row.item.id)">Delete</b-button>
      </template>
    </b-table>
    <b-card-footer>
      <p><strong>New Payment Method</strong></p>
      <b-form>
        <div class="row">
          <div class="col-md-3">
            <label class="sr-only" for="card-holder-name">Card Holder Name</label>
            <b-form-input size="sm" id="card-holder-name" v-model="name" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Card Holder Name"></b-form-input>
          </div>
          <div class="col-md-6">
            <label class="sr-only" for="card-element">Card</label>
            <div id="card-element" class="mb-2 mr-sm-2 mb-sm-0"></div>
          </div>
          <div class="col-md-3">
            <b-button size="sm" variant="success" id="add-card-button" @click="submitPaymentMethod">Save Payment Method</b-button>
          </div>
        </div>
      </b-form>
    </b-card-footer>
  </b-card>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel
  },
  data: function() {
    return {
      stripeAPIToken: '',
      payment_methods: [],
      intentToken: '',
      name: '',
      addPaymentStatus: 0,
      addPaymentStatusError: '',
      stripe: '',
      elements: '',
      card: '',
      fields: [
        {
          key: 'brand',
          label: 'Card Type'
        },
        {
          key: 'last_four'
        },
        {
          key: 'exp_month'
        },
        {
          key: 'exp_year'
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      loading: true
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    }
  },
  methods: {
    async getStripeKey() {
      axios.get(process.env.VUE_APP_API_BASE_URL + '/stripe-key')
      .then(response => {
        this.stripeAPIToken = response.data;
        this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
        }.bind(this));
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getPaymentMethods() {
      axios.get(this.userRoute + "/payments")
        .then(response => {
          this.loading = false;
          this.payment_methods = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    },
    async getSetupIntent() {
      axios.get(this.userRoute + "/setup-intent")
        .then(response => {
          this.intentToken = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    },
    async submitPaymentMethod() {
      this.addPaymentStatus = 1;

      this.stripe.confirmCardSetup(
        this.intentToken.client_secret, {
          payment_method: {
            card: this.card,
            billing_details: {
                name: this.name
            }
          }
        }
      ).then(result => {
        if (result.error) {
          this.addPaymentStatus = 3;
          this.addPaymentStatusError = result.error.message;
        } else {
          this.loading_cards = true;
          this.savePaymentMethod(result.setupIntent.payment_method);
          this.addPaymentStatus = 2;
          this.card.clear();
          this.name = '';
        }
      });
    },
    async savePaymentMethod(method) {
      axios.post(this.userRoute + "/payments", {
        payment_method: method
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.getPaymentMethods();
        this.$store.dispatch('profile/user');
      })
      .catch(error => {
        this.error(error);
      });
    },
    includeStripe(URL, callback){
      let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe(){
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');

      this.card.mount('#card-element');
    },
    async removePaymentMethod(paymentID){
      this.loading_cards = true;
      axios.post(this.userRoute + "/remove-payment", {
        payment_method: paymentID
      }).then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.getPaymentMethods();
      });
    }
  },
  created() {
    this.getPaymentMethods();
    this.getSetupIntent();
  },
  mounted() {
    this.getStripeKey();
  }
};
</script>
